function r(n){return()=>n}export{r as a};
